import React from 'react';
import styled from '@emotion/styled';
import sizes from 'style/sizes';
import { mq } from 'style/variables';
import Img from 'components/atoms/img';

type FullImgProps = {
  imgpath: string;
  alt: string;
};

const Container = styled.div`
  width: 100%;
  ${mq.onlypc} {
    max-width: 1920px;
    margin: 0 auto ${sizes.margin[209]};
  }
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[100]};
  }
`;

export const FullImg: React.FC<FullImgProps> = props => {
  return (
    <Container {...props}>
      <Img filename={props.imgpath} alt={props.alt} />
    </Container>
  );
};
